var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramGreenLoan64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-123.000000, -87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(123.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Greenloan",
    transform: "translate(4.000000, 10.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tree",
    transform: "translate(0.373347, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126652953,14.4997431 C0.126652953,22.5080532 6.61859973,29 14.6269099,29 C22.6347062,29 29.126653,22.5080532 29.126653,14.4997431 C29.126653,6.49194677 22.6347062,0 14.6269099,0 C6.61859973,0 0.126652953,6.49194677 0.126652953,14.4997431 Z",
    id: "Stroke-70",
    fill: "#00AA00"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.626653,
    y1: 14,
    x2: 14.626653,
    y2: 45,
    id: "Stroke-74"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-76",
    points: "19.126653 19 14.62641 24 10.126653 19"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Home",
    fill: "#FFFFFF",
    points: "21 21.6595745 37 9 53 21.6595745 53 44 21 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Focus",
    points: "47 30 40 30 40 23 47 23"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramGreenLoan64);
export default __webpack_public_path__ + "static/media/pictogramGreenLoan64.a42ae02e8155d04de88def93803baf43.svg";
export { ForwardRef as ReactComponent };